import React from 'react';
import { InfoRow, DetailedRequest, ExpandWrapper, RecentActivity } from './styled';
import { BuildingPermitItem } from '../../types';
import { ExpandedInfoItem } from '../expanded-info';
import { useLocale } from 'locale';
import { SmallText } from 'ds/components/typography';
import { Link } from 'ds/components/link';
import { ShowAt } from 'consts/breakpoints';

const ExpandedInfo: React.FC<{ item: BuildingPermitItem }> = ({ item }) => {
  const { t, formatDate } = useLocale();
  const { detailedRequest, requestorName, ownerName, applicationNumber, applicationPageLink, requestDate } = item;
  return (
    <ShowAt at={1}>
      {(isMobile => (
        <ExpandWrapper>
          {isMobile && requestDate ? (
            <InfoRow>
              <ExpandedInfoItem label={t('widget.buildingPermit.requestDate')} value={formatDate(requestDate)} />
            </InfoRow>
          ) : null}
          {detailedRequest ? (
            <DetailedRequest>
              {detailedRequest}
            </DetailedRequest>
          ) : null}
          {requestorName ? (
            <InfoRow>
              <ExpandedInfoItem label={t('widget.buildingPermit.requestorName')} value={requestorName} />
            </InfoRow>
          ) : null}
          {ownerName ? (
            <InfoRow>
              <ExpandedInfoItem label={t('widget.buildingPermit.ownerName')} value={ownerName} />
            </InfoRow>
          ) : null}
          {applicationNumber ? (
            <InfoRow>
              <ExpandedInfoItem label={t('widget.buildingPermit.requestNumber')} value={applicationNumber} />
            </InfoRow>
          ) : null}
          {item.recentActivity.length ? (
            <RecentActivity>
              <InfoRow>
                <SmallText>
                  {t('widget.buildingPermit.recentActivity')}
                </SmallText>
              </InfoRow>
              {item.recentActivity.slice(0, isMobile ? 3 : 5).map(event => (
                <InfoRow>
                  <ExpandedInfoItem label={formatDate(event.eventDate)} value={event.eventName}/>
                </InfoRow>
              ))}
            </RecentActivity>
          ) : null}
          {applicationPageLink ? (
            <Link target="_blank" href={applicationPageLink}>
              <SmallText>
                {t('widget.buildingPermit.applicationPageLink')}
              </SmallText>
            </Link>
          ) : null}
        </ExpandWrapper>
      ))}
    </ShowAt>
  );
};


export default ExpandedInfo;
